import { all } from 'redux-saga/effects';
import { downloadCdrSaga, getRecordsSaga, downloadCdrALegSaga } from './records.action';

export { getRecords, downloadCdr, downloadCdrALeg } from './records.action';
export { default as recordsReducer } from './records.reducer';

export const recordsSaga = function* () {
  yield all([getRecordsSaga(), downloadCdrSaga(), downloadCdrALegSaga()]);
};
